
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "doprava",
  "use": "doprava-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"doprava\"><g fill=\"none\"><path d=\"M52.28 11.573l19.937 49.073M17.055 60.646l19.937-49.073\" /><g><path d=\"M44.636 61.162V49.824M44.636 39.902v-8.503M44.636 24.312v-5.67M44.636 13.89v-2.834\" /></g></g></symbol>"
});
    sprite.add(symbol);

    export default class DopravaSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="doprava" {...this.props} />;
      }
    }
  